import { html, TemplateElement } from '@webtides/element-js';

export default class SocialMediaWallPagination extends TemplateElement {
    properties() {
        return {
            loadMoreLabel: 'Mehr laden',
        };
    }

    injectProperties() {
        return {
            socialMediaWallStore: {},
        };
    }

    events() {
        return {
            '[ref=loadMore]': {
                click: () => {
                    this.socialMediaWallStore.updatePosts();
                },
            },
        };
    }
    template() {
        return html`
            <div class="text-center">
                <button ref="loadMore" class="btn btn-primary">${this.loadMoreLabel}</button>
            </div>
        `;
    }
}
